import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../auth.service';
import { User } from '../../user';

export interface TeacherDialogData {
  tenantId: number;
  /**
   * Same API as add teacher; when true, admin picks Teacher vs Admin role.
   * Students are provisioned elsewhere (student records / admissions).
   */
  allowRoleChoice?: boolean;
}

@Component({
  selector: 'app-teacher-dialog',
  templateUrl: './teacher-dialog.component.html',
  styleUrls: ['./teacher-dialog.component.css']
})
export class TeacherDialogComponent {

  form: FormGroup;
  hidePassword = true;
  saving = false;
  msg = '';

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<TeacherDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: TeacherDialogData,
    private authService: AuthService
  ) {
    this.form = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      phoneNumber: [''],
      role: ['ROLE_TEACHER', [Validators.required]]
    });
    if (!this.data.allowRoleChoice) {
      this.form.get('role')?.disable();
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  submit(): void {
    this.msg = '';
    if (this.form.invalid || this.data.tenantId == null) {
      return;
    }
    const v = this.form.getRawValue();
    const role = (v.role as string) || 'ROLE_TEACHER';
    const payload = Object.assign(new User(), {
      username: v.username.trim(),
      email: v.email.trim(),
      password: v.password,
      tenantId: this.data.tenantId,
      roles: [role],
      firstName: v.firstName.trim(),
      lastName: v.lastName.trim(),
      fatherName: '',
      motherName: '',
      phoneNumber: (v.phoneNumber || '').trim()
    });

    this.saving = true;
    this.authService.registerUserFromRemote(payload).subscribe(
      () => {
        this.saving = false;
        this.dialogRef.close(true);
      },
      () => {
        this.saving = false;
        this.msg = 'Could not create account. Username or email may already exist.';
      }
    );
  }
}
